import type { FaireProductEntity } from "../../entity_types/product";

export const p_gav69pcvgp: FaireProductEntity = {
  token: "p_gav69pcvgp",
  type: "product",
  name: "DRESDEN",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl:
    "https://cdn.faire.com/fastly/28abbddd32860f79c4a149c2681b4c3be43f7bbb639fd4110414a83ba7ba2edf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/527fd26c4d77a262b84a4fe8bcff639ca6d26c9b338c7226d6f622cb503f3dd8.jpeg",
    "https://cdn.faire.com/fastly/3127e6143aaa1d0c3638408ad62112ae100bd7eb381536a77c6d6920056b36e3.jpeg",
    "https://cdn.faire.com/fastly/de7b345ba26f6551813afcc05032d4a4e9d2da631a4f743fcd749ce09275c958.jpeg",
    "https://cdn.faire.com/fastly/84f6cfd46584af10a62c34054d839435b1f16cb4126c0a33bed09d95c4acba6d.jpeg",
    "https://cdn.faire.com/fastly/68bbcfab4a4f39a74e254a362b746e4baf2624b2b8d05b5260f423413e9aab47.jpeg",
  ],
  priceDollars: 19,
  description:
    "Smells like an old Hollywood secret, dimly lit bar and crisp cocktail. This scent walks the line between fresh and moody. Citrusy notes are softened by warm oud and a hint of black pepper. It's not quite fresh, not quite woody - just unmistakably cool.\n\nkaffir lime, wild bergamot, marjoram, cracked pepper, oud\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn. We use lead-free cotton wicks and premium fragrance oils. All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials.\n\n8.4 ounces (228g), comes in our signature pink box.",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:13.340Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
